import { Modal } from 'antd';
import type { ModalFuncProps } from 'antd/es/modal';
import { createContext, useContext, useEffect, useState } from 'react';

interface ModalContextProps {
    setModalOption: (value: ModalOption) => void;
    destroy: () => void;
}

interface ModalProviderProps {
    children: React.ReactNode;
}

interface Instance {
    destroy: () => void;
    update: (config: ModalFuncProps) => void;
}

const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export enum ModalType {
    ERROR = 'error',
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning',
    CONFIRM = 'confirm',
}
export type ModalOption = ModalFuncProps;
export const ModalProvider = ({ children }: ModalProviderProps) => {
    const [modal, contextHolder] = Modal.useModal();
    const [option, setModalOption] = useState<ModalOption>();
    const [instance, setInstance] = useState<Instance>();

    const destroy = () => {
        setInstance(undefined);
        Modal.destroyAll();
    };

    useEffect(() => {
        if (option) {
            if (instance) {
                instance.update(option);
            } else {
                const instance = modal.confirm(option);
                setInstance(instance);
            }
        }
    }, [option]);

    return (
        <ModalContext.Provider value={{ setModalOption, destroy }}>
            {contextHolder}
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (context === undefined) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
